/* global window, document, Tabulator */

(function (window, document) {
    var root = document.getElementById('radar-aziende-root');
    if (!root) {
        return;
    }

    var VG_RADAR_AZIENDE_MODE_STORAGE_KEY = 'vg-radar-aziende-mode';
    var _vgRadarGatewaySessionOk = false;
    var _vgCompanyBundle = null; // { profileId, territories: [], cpv: [] }
    var _vgRadarLastMode = null;

    function qs(sel, el) {
        return (el || document).querySelector(sel);
    }

    function getMagicFromUrl() {
        try {
            var url = new URL(window.location.href);
            return url.searchParams.get('magic');
        } catch (e) {
            return null;
        }
    }

    function setStatus(msg) {
        var el = qs('[data-radar-status]', root);
        if (el) el.textContent = msg || '';
    }

    function persistRadarMode(mode) {
        try {
            if (mode === 'company' || mode === 'explore') {
                localStorage.setItem(VG_RADAR_AZIENDE_MODE_STORAGE_KEY, mode);
            }
        } catch (e) {}
    }

    function loadRadarMode() {
        try {
            var m = localStorage.getItem(VG_RADAR_AZIENDE_MODE_STORAGE_KEY);
            return m === 'company' ? 'company' : 'explore';
        } catch (e) {
            return 'explore';
        }
    }

    function fetchGhostSessionToken() {
        return fetch('/members/api/session/', { method: 'GET', credentials: 'include' })
            .then(function (r) {
                if (r.status === 204) return null;
                if (!r.ok) {
                    return r.text().then(function (t) {
                        throw new Error('Ghost session HTTP ' + r.status + (t ? ' ' + t.slice(0, 120) : ''));
                    });
                }
                return r.text();
            })
            .then(function (token) {
                token = (token || '').trim();
                return token || null;
            });
    }

    function gatewaySessionLogin(sessionToken) {
        var api = String((root.getAttribute('data-api-base') || '')).replace(/\/+$/, '');
        if (!api) return Promise.reject(new Error('API base mancante'));
        return fetch(api + '/auth/ghost/session/login', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ session_token: sessionToken })
        }).then(function (r) {
            return r.json().then(function (data) {
                if (!r.ok) {
                    var d = (data && data.detail) ? String(data.detail) : '';
                    throw new Error(d || ('Gateway login HTTP ' + r.status));
                }
                return data;
            });
        });
    }

    function ensureGatewaySession() {
        if (_vgRadarGatewaySessionOk) return Promise.resolve();
        return fetchGhostSessionToken()
            .then(function (token) {
                if (!token) throw new Error('Accedi per caricare il profilo aziendale');
                return gatewaySessionLogin(token);
            })
            .then(function () {
                _vgRadarGatewaySessionOk = true;
            });
    }

    function escHtml(s) {
        if (s == null) return '';
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    /** Parse EUR amounts from API (number or string). Never strip '.' blindly — "221871.58" as string must stay decimal. */
    function parseEuroNumber(v) {
        if (v == null || v === '') return NaN;
        if (typeof v === 'number' && isFinite(v)) return v;
        var s = String(v).trim().replace(/\s/g, '');
        if (!s) return NaN;
        if (s.indexOf(',') !== -1 && s.indexOf('.') !== -1) {
            return parseFloat(s.replace(/\./g, '').replace(',', '.'), 10);
        }
        if (s.indexOf(',') !== -1) {
            return parseFloat(s.replace(',', '.'), 10);
        }
        return parseFloat(s, 10);
    }

    function formatEuroIt(v) {
        var n = parseEuroNumber(v);
        if (!isFinite(n)) return '—';
        return (
            n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
        );
    }

    function formatIntIt(v) {
        var n = Number(v);
        if (!isFinite(n)) return '—';
        return Math.round(n).toLocaleString('it-IT', { maximumFractionDigits: 0 });
    }

    /** From Jan 1st (current year) to today in browser local timezone. */
    function currentYearToTodayRangeISO() {
        var now = new Date();
        var y = now.getFullYear();
        var start = new Date(y, 0, 1);
        var end = now;
        function pad(n) {
            return n < 10 ? '0' + n : String(n);
        }
        return {
            date_from: start.getFullYear() + '-' + pad(start.getMonth() + 1) + '-' + pad(start.getDate()),
            date_to: end.getFullYear() + '-' + pad(end.getMonth() + 1) + '-' + pad(end.getDate())
        };
    }

    function applyDefaultDateFiltersIfEmpty() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var df = form.querySelector('input[name="date_from"]');
        var dt = form.querySelector('input[name="date_to"]');
        if (!df || !dt) return;
        if (String(df.value || '').trim() !== '' || String(dt.value || '').trim() !== '') {
            return;
        }
        var r = currentYearToTodayRangeISO();
        df.value = r.date_from;
        dt.value = r.date_to;
    }

    function readFilters() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return {};
        var fd = new FormData(form);
        var out = {};
        ['date_from', 'date_to', 'cpv'].forEach(function (k) {
            var v = fd.get(k);
            if (v != null && String(v).trim() !== '') {
                out[k] = String(v).trim();
            }
        });
        var companyCb = form.querySelector('#radar-aziende-company-mode');
        if (companyCb && companyCb.checked && !companyCb.disabled) {
            var mem2 = (root.getAttribute('data-member-uuid') || '').trim();
            if (mem2) {
                out.member = mem2;
            }
            var b = _vgCompanyBundle;
            var prefs = companyCpvPrefixesFromBundle(b && b.cpv);
            if (prefs && prefs.length) {
                out.cpv_prefixes = prefs.join(',');
            }
            // Territories filter is optional in company mode (unchecked = tutta Italia).
            var terrCb = form.querySelector('#radar-aziende-in-saved-area');
            if (terrCb && terrCb.checked) {
                out.company_mode = '1';
            }
            // mutual exclusion: do not send in_saved_area when company_mode
            return out;
        }
        var areaCb = form.querySelector('#radar-aziende-in-saved-area');
        if (areaCb && areaCb.checked && !areaCb.disabled) {
            out.in_saved_area = '1';
            // Same Ghost member UUID as /telegram/settings?member= (no JWT required server-side).
            var mem = (root.getAttribute('data-member-uuid') || '').trim();
            if (mem) {
                out.member = mem;
            }
        }
        return out;
    }

    function stripTrailingZerosToPrefix(code) {
        var s = String(code || '').replace(/\D/g, '');
        if (!s) return '';
        if (s.length > 8) s = s.slice(0, 8);
        s = s.replace(/0+$/g, '');
        return s || String(code || '').replace(/\D/g, '').slice(0, 8);
    }

    function companyCpvPrefixesFromBundle(cpvItems) {
        var out = [];
        (cpvItems || []).forEach(function (it) {
            var raw = it && (it.cpv_code || it.code || it.cpv || it.value);
            var p = stripTrailingZerosToPrefix(raw || '');
            if (p && out.indexOf(p) === -1) out.push(p);
        });
        return out;
    }

    function initCpvAutocomplete() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var input = form.querySelector('input[name="cpv_query"]');
        var hidden = form.querySelector('input[name="cpv"]');
        var clearBtn = form.querySelector('[data-cpv-clear]');
        var list = document.getElementById('radar-aziende-cpv-list');
        if (!input || !hidden || !list) return;
        var memberUuid = (root.getAttribute('data-member-uuid') || '').trim();

        var lastFetch = 0;
        var pending;
        var saveTimer;

        function persistCpv(prefix) {
            if (!memberUuid) return;
            if (saveTimer) window.clearTimeout(saveTimer);
            saveTimer = window.setTimeout(function () {
                fetch(apiBase + '/telegram/cpv', {
                    method: 'POST',
                    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
                    body: JSON.stringify({ member_uuid: memberUuid, cpv_prefix: prefix || null })
                }).catch(function () {});
            }, 220);
        }

        function syncClearBtn() {
            if (!clearBtn) return;
            clearBtn.disabled = !String(hidden.value || '').trim();
        }

        var lastResolvedPrefix = '';
        function resolveAndShowLabel(prefix) {
            var p = String(prefix || '').trim();
            if (!p || p === lastResolvedPrefix) return Promise.resolve();
            lastResolvedPrefix = p;
            var url = apiBase + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(p) + '&limit=1';
            return fetch(url, { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : {}; })
                .then(function (data) {
                    var it = data && data.items && data.items[0];
                    if (!it) return;
                    var code = String(it.code_main || '').trim();
                    var label = String(it.label_it || '').trim();
                    if (!code) return;
                    input.value = code + (label ? ' — ' + label : '');
                })
                .catch(function () {});
        }

        function render(items) {
            while (list.firstChild) list.removeChild(list.firstChild);
            (items || []).forEach(function (it) {
                var opt = document.createElement('option');
                var code = it.code_main || '';
                var label = it.label_it || '';
                opt.value = code + (label ? ' — ' + label : '');
                list.appendChild(opt);
            });
        }

        function fetchSuggest(q) {
            var now = Date.now();
            lastFetch = now;
            var url = apiBase + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(q) + '&limit=15';
            return fetch(url, { headers: { Accept: 'application/json' } })
                .then(function (r) { if (!r.ok) throw r; return r.json(); })
                .then(function (data) {
                    if (lastFetch !== now) return;
                    render((data && data.items) || []);
                })
                .catch(function () {});
        }

        input.addEventListener('input', function () {
            var q = String(input.value || '').trim();
            if (pending) window.clearTimeout(pending);
            if (q.length < 2 && !/\d/.test(q)) return;
            pending = window.setTimeout(function () { fetchSuggest(q); }, 180);
        });

        // Keep hidden prefix in sync while typing digits-only.
        input.addEventListener('input', function () {
            var raw = String(input.value || '').trim();
            var digits = raw.replace(/\D/g, '');
            hidden.value = digits ? stripTrailingZerosToPrefix(digits) : '';
            persistCpv(hidden.value);
            syncClearBtn();
        });

        // If user picked "CODE — label", normalize to prefix (strip trailing zeros).
        input.addEventListener('blur', function () {
            var raw = String(input.value || '').trim();
            if (!raw) {
                hidden.value = '';
                persistCpv('');
                lastResolvedPrefix = '';
                syncClearBtn();
                return;
            }
            var digits = raw.replace(/\D/g, '');
            if (!digits) return;
            // keep the visible label intact; store prefix in hidden field
            hidden.value = stripTrailingZerosToPrefix(digits);
            persistCpv(hidden.value);
            syncClearBtn();
            resolveAndShowLabel(hidden.value);
        });

        if (clearBtn) {
            clearBtn.addEventListener('click', function () {
                input.value = '';
                hidden.value = '';
                lastResolvedPrefix = '';
                persistCpv('');
                syncClearBtn();
            });
        }

        syncClearBtn();

        if (memberUuid) {
            fetch(apiBase + '/telegram/settings?member=' + encodeURIComponent(memberUuid), { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : {}; })
                .then(function (data) {
                    var p = String((data && data.cpv_prefix) || '').trim();
                    if (!p) return;
                    hidden.value = p;
                    syncClearBtn();
                    resolveAndShowLabel(p);
                })
                .catch(function () {});
        }
    }

    function renderKpi(data) {
        if (!data) return;
        var wr = parseEuroNumber(data.win_rate);
        var winRateStr =
            data.win_rate != null && data.win_rate !== '' && isFinite(wr)
                ? (wr <= 1 ? wr * 100 : wr).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }) + ' %'
                : '—';
        var map = {
            companies_count: formatIntIt(data.companies_count),
            participations_total: formatIntIt(data.participations_total),
            wins_total: formatIntIt(data.wins_total),
            win_rate: winRateStr,
            awarded_amount_eur_sum:
                data.awarded_amount_eur_sum != null && data.awarded_amount_eur_sum !== ''
                    ? formatEuroIt(data.awarded_amount_eur_sum)
                    : '—',
            awarded_amount_eur_avg:
                data.awarded_amount_eur_avg != null && data.awarded_amount_eur_avg !== ''
                    ? formatEuroIt(data.awarded_amount_eur_avg)
                    : '—'
        };
        Object.keys(map).forEach(function (key) {
            var el = qs('[data-radar-kpi="' + key + '"]', root);
            if (el) el.textContent = map[key] != null ? String(map[key]) : '—';
        });
        var note = qs('[data-radar-kpi-note]', root);
        if (note && data.sample_note) note.textContent = data.sample_note;
    }

    var apiBase = (root.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    var siteUrl = (root.getAttribute('data-site-url') || '').replace(/\/+$/, '');
    var client = new window.AppaltiMap.ApiGatewayClient({
        baseUrl: apiBase,
        tokenStore: new window.AppaltiMap.TokenStore('appaltimap_auth')
    });

    function fetchCompanyBundleForRadar() {
        if (_vgCompanyBundle) return Promise.resolve(_vgCompanyBundle);
        return ensureGatewaySession()
            .then(function () {
                return fetch(apiBase + '/company-profiles?limit=1&offset=0', {
                    credentials: 'include',
                    headers: { Accept: 'application/json' }
                });
            })
            .then(function (r) {
                return r.json().then(function (j) {
                    if (!r.ok) throw new Error((j && j.detail && String(j.detail)) || ('HTTP ' + r.status));
                    return j;
                });
            })
            .then(function (list) {
                var items = (list && list.items) ? list.items : [];
                if (!items.length) return { profileId: null, territories: [], cpv: [] };
                var pid = items[0].id;
                return fetch(apiBase + '/company-profiles/' + encodeURIComponent(pid) + '/bundle', {
                    credentials: 'include',
                    headers: { Accept: 'application/json' }
                })
                    .then(function (r2) {
                        return r2.json().then(function (j2) {
                            if (!r2.ok) throw new Error((j2 && j2.detail && String(j2.detail)) || ('HTTP ' + r2.status));
                            return j2;
                        });
                    })
                    .then(function (bundle) {
                        return {
                            profileId: pid,
                            territories: (bundle && bundle.territories) ? bundle.territories : [],
                            cpv: (bundle && bundle.cpv) ? bundle.cpv : []
                        };
                    });
            })
            .then(function (b) {
                _vgCompanyBundle = b;
                return b;
            })
            .catch(function () {
                _vgCompanyBundle = { profileId: null, territories: [], cpv: [] };
                return _vgCompanyBundle;
            });
    }

    function uncheckSavedAreaIfAuthOrAreaError(status) {
        if (status !== 400 && status !== 401) return;
        var cb = document.getElementById('radar-aziende-in-saved-area');
        if (cb && cb.checked) cb.checked = false;
    }

    function initSavedAreaFromMap() {
        var uuid = (root.getAttribute('data-member-uuid') || '').trim();
        var cb = document.getElementById('radar-aziende-in-saved-area');
        var hint = document.getElementById('radar-aziende-area-hint');
        if (!cb) return Promise.resolve();
        if (!uuid) {
            cb.disabled = true;
            if (hint) {
                hint.hidden = false;
                hint.textContent = 'UUID membro non disponibile: impossibile verificare l’area sulla mappa.';
            }
            return Promise.resolve();
        }
        return fetch(apiBase + '/telegram/settings?member=' + encodeURIComponent(uuid), {
            headers: { Accept: 'application/json' }
        })
            .then(function (r) {
                return r.ok ? r.json() : {};
            })
            .then(function (data) {
                var hasArea = data && data.mode === 'area' && data.area && data.area.geojson;
                if (hasArea) {
                    cb.disabled = false;
                    if (hint) {
                        hint.hidden = true;
                        hint.textContent = '';
                    }
                } else {
                    cb.disabled = true;
                    cb.checked = false;
                    if (hint) {
                        hint.hidden = false;
                        hint.textContent =
                            'Salva un’area sulla mappa principale (strumento disegno) per abilitare questo filtro.';
                    }
                }
            })
            .catch(function () {
                cb.disabled = true;
                if (hint) {
                    hint.hidden = false;
                    hint.textContent = 'Impossibile verificare se hai un’area salvata sulla mappa.';
                }
            });
    }

    function applyCompanyModeUi(mode) {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var chkCompany = form.querySelector('#radar-aziende-company-mode');
        var chkArea = form.querySelector('#radar-aziende-in-saved-area');
        var hintArea = document.getElementById('radar-aziende-area-hint');
        var hintCompany = document.getElementById('radar-aziende-company-hint');
        var wrapArea = document.getElementById('radar-aziende-saved-area-wrap');
        var areaLabelSpan = wrapArea ? wrapArea.querySelector('span') : null;
        var cpvInput = form.querySelector('input[name="cpv_query"]');
        var cpvHidden = form.querySelector('input[name="cpv"]');
        var clearBtn = form.querySelector('[data-cpv-clear]');

        var AREA_LABEL_EXPLORE = "Solo bandi nell’area salvata sulla mappa principale";
        var AREA_LABEL_COMPANY = "Solo bandi nei territori salvati su company profile.";

        function resetCpvToEmpty() {
            if (cpvHidden) cpvHidden.value = '';
            if (cpvInput) cpvInput.value = '';
            if (clearBtn) {
                clearBtn.disabled = true;
            }
        }

        function setCompanyHint(msg, visible) {
            if (!hintCompany) return;
            hintCompany.hidden = !visible;
            hintCompany.textContent = visible ? (msg || '') : '';
        }

        if (mode !== 'company') {
            // leaving company -> explore: reset CPV as requested
            if (_vgRadarLastMode === 'company') {
                resetCpvToEmpty();
            }
            if (chkArea) chkArea.checked = false;
            if (chkCompany) chkCompany.checked = false;
            if (cpvInput) cpvInput.disabled = false;
            if (clearBtn) clearBtn.disabled = !String((cpvHidden && cpvHidden.value) || '').trim();
            if (areaLabelSpan) areaLabelSpan.textContent = AREA_LABEL_EXPLORE;
            setCompanyHint('', false);
            _vgRadarLastMode = 'explore';
            // restore the real saved-area enable/disable state
            initSavedAreaFromMap();
            return;
        }

        // company mode
        if (chkArea) {
            chkArea.disabled = false; // user can uncheck to get whole Italy
        }
        if (chkCompany) {
            chkCompany.checked = true;
        }
        if (areaLabelSpan) areaLabelSpan.textContent = AREA_LABEL_COMPANY;
        if (hintArea) {
            // keep saved-area hint state as is; it's still useful when not in company mode,
            // but in company mode the checkbox is disabled anyway.
        }

        fetchCompanyBundleForRadar().then(function (b) {
            var territories = (b && b.territories) ? b.territories : [];
            var hasTerritories = territories && territories.length > 0;
            if (!hasTerritories) {
                if (chkCompany) {
                    chkCompany.checked = false;
                    chkCompany.disabled = true;
                }
                setCompanyHint('Company profile: non ci sono territori configurati (aggiungili nel Company Profile).', true);
                persistRadarMode('explore');
                applyCompanyModeUi('explore');
                return;
            }

            if (chkCompany) chkCompany.disabled = false;
            var cpvPrefs = companyCpvPrefixesFromBundle(b && b.cpv);
            if (cpvInput) {
                cpvInput.disabled = true;
                cpvInput.value = cpvPrefs.length ? cpvPrefs.join(', ') : '';
            }
            if (cpvHidden) cpvHidden.value = ''; // don't send single cpv in company mode
            if (clearBtn) clearBtn.disabled = true;
            setCompanyHint('', false);
            _vgRadarLastMode = 'company';
        });
    }

    function initCompanyModeToggle() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var chkCompany = form.querySelector('#radar-aziende-company-mode');
        if (!chkCompany) return;

        // Start disabled until we know territories exist.
        chkCompany.disabled = true;

        fetchCompanyBundleForRadar().then(function (b) {
            var territories = (b && b.territories) ? b.territories : [];
            var hasTerritories = territories && territories.length > 0;
            if (!hasTerritories) {
                chkCompany.disabled = true;
                chkCompany.checked = false;
                persistRadarMode('explore');
                applyCompanyModeUi('explore');
                var hintCompany = document.getElementById('radar-aziende-company-hint');
                if (hintCompany) {
                    hintCompany.hidden = false;
                    hintCompany.textContent = 'Company profile: non ci sono territori configurati (aggiungili nel Company Profile).';
                }
                return;
            }

            chkCompany.disabled = false;
            var mode0 = loadRadarMode();
            chkCompany.checked = mode0 === 'company';
            applyCompanyModeUi(chkCompany.checked ? 'company' : 'explore');
        });

        chkCompany.addEventListener('change', function () {
            var on = !!chkCompany.checked;
            var mode = on ? 'company' : 'explore';
            persistRadarMode(mode);
            applyCompanyModeUi(mode);
        });
    }

    /** Same pattern as appaltimap-home.js initHomeMap: optional ?magic= exchange, shared localStorage. */
    function exchangePromiseFromUrl() {
        var magic = getMagicFromUrl();
        var p = Promise.resolve();
        if (magic) {
            p = new window.AppaltiMap.ExchangeTokenCommand(client, magic)
                .execute()
                .then(function () {
                    setStatus('Signed in for map access.');
                })
                .catch(function () {
                    setStatus('Token exchange failed.');
                });
        }
        return p;
    }

    function loadKpi() {
        var filters = readFilters();
        setStatus('Aggiornamento KPI…');
        var url = new URL(apiBase + '/radar/hub/kpi', window.location.origin);
        Object.keys(filters || {}).forEach(function (k) {
            var v = filters[k];
            if (v != null && String(v).trim() !== '') {
                url.searchParams.set(k, String(v));
            }
        });
        var token = client.tokenStore.getToken() || '';
        var headers = { Accept: 'application/json' };
        if (token) headers.Authorization = 'Bearer ' + token;
        return fetch(url.toString(), { headers: headers })
            .then(function (r) {
                if (!r.ok) {
                    return r.text().then(function (t) {
                        var msg = r.statusText || 'Errore';
                        try {
                            var body = JSON.parse(t);
                            var d = body && body.detail;
                            msg =
                                typeof d === 'string'
                                    ? d
                                    : d
                                      ? JSON.stringify(d)
                                      : msg;
                        } catch (ignore) {}
                        setStatus(msg);
                        uncheckSavedAreaIfAuthOrAreaError(r.status);
                        throw new Error(msg);
                    });
                }
                return r.json();
            })
            .then(function (data) {
                renderKpi(data);
                setStatus('');
            })
            .catch(function (err) {
                if (!err || !err.message) {
                    setStatus('Impossibile caricare i KPI.');
                }
            });
    }

    var table;

    function buildTable() {
        if (typeof Tabulator === 'undefined') {
            setStatus('Tabulator non disponibile.');
            return;
        }
        var tableEl = qs('#radar-aziende-table', root);
        if (!tableEl) return;
        if (table) return;

        table = new Tabulator(tableEl, {
            layout: 'fitColumns',
            placeholder: 'Nessun dato',
            pagination: true,
            paginationMode: 'remote',
            paginationSize: 25,
            paginationSizeSelector: [25, 50, 100],
            paginationInitialPage: 1,
            ajaxURL: apiBase + '/radar/hub/suppliers',
            ajaxParams: function () {
                var f = readFilters();
                return f;
            },
            ajaxRequestFunc: function (url, config, params) {
                var token = client.tokenStore.getToken() || '';
                var headers = { Accept: 'application/json' };
                if (token) headers.Authorization = 'Bearer ' + token;
                var sep = url.indexOf('?') >= 0 ? '&' : '?';
                var qs = new URLSearchParams(params || {}).toString();
                var fullUrl = qs ? url + sep + qs : url;
                return fetch(fullUrl, { method: 'GET', headers: headers }).then(function (r) {
                    if (!r.ok) {
                        return r.text().then(function (t) {
                            var msg = r.statusText || 'Errore';
                            try {
                                var body = JSON.parse(t);
                                var d = body && body.detail;
                                msg =
                                    typeof d === 'string'
                                        ? d
                                        : d
                                          ? JSON.stringify(d)
                                          : msg;
                            } catch (ignore) {}
                            setStatus(msg);
                            uncheckSavedAreaIfAuthOrAreaError(r.status);
                            throw new Error(msg);
                        });
                    }
                    return r.json();
                });
            },
            ajaxResponse: function (url, params, response) {
                var perPage = response.per_page || params.size || 25;
                var total = response.total || 0;
                var lastPage = Math.max(1, Math.ceil(total / perPage) || 1);
                return {
                    last_page: lastPage,
                    data: response.items || []
                };
            },
            columns: [
                {
                    title: 'Azienda',
                    field: 'canonical_name',
                    minWidth: 180,
                    formatter: function (cell) {
                        var row = cell.getRow().getData();
                        var path = row.supplier_url_path || '/';
                        var href = siteUrl ? siteUrl + path : path;
                        var name = cell.getValue() || row.normalized_name || '—';
                        return '<a href="' + String(href).replace(/"/g, '') + '">' + escHtml(name) + '</a>';
                    }
                },
                {
                    title: 'Partecipazioni',
                    field: 'stats_participations_total',
                    width: 130,
                    hozAlign: 'right',
                    formatter: function (cell) {
                        return formatIntIt(cell.getValue());
                    }
                },
                {
                    title: 'Vittorie',
                    field: 'stats_wins_total',
                    width: 90,
                    hozAlign: 'right',
                    formatter: function (cell) {
                        return formatIntIt(cell.getValue());
                    }
                },
                {
                    title: 'Win rate %',
                    field: 'stats_win_rate',
                    width: 100,
                    hozAlign: 'right',
                    formatter: function (cell) {
                        var v = cell.getValue();
                        if (v == null || v === '') return '—';
                        var n = parseEuroNumber(v);
                        if (!isFinite(n)) return '—';
                        return (
                            n.toLocaleString('it-IT', {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 2
                            }) + ' %'
                        );
                    }
                },
                {
                    title: 'Importo aggiudicato (EUR)',
                    field: 'stats_total_awarded_amount_eur',
                    minWidth: 150,
                    hozAlign: 'right',
                    formatter: function (cell) {
                        var v = cell.getValue();
                        if (v == null || v === '') return '—';
                        return formatEuroIt(v);
                    }
                },
                { title: 'Ultimo agg.', field: 'last_seen_at', width: 160 }
            ]
        });
        root._vgTabulator = table;
    }

    function refreshAll() {
        loadKpi().then(function () {
            if (table) {
                table.setData();
            }
        }).catch(function () {});
    }

    function bindForm() {
        var form = qs('[data-radar-filters]', root);
        if (form) {
            form.addEventListener('submit', function (e) {
                e.preventDefault();
                exchangePromiseFromUrl().finally(function () {
                    refreshAll();
                });
            });
        }
    }

    function run() {
        bindForm();
        applyDefaultDateFiltersIfEmpty();
        initCpvAutocomplete();
        initCompanyModeToggle();
        exchangePromiseFromUrl().finally(function () {
            initSavedAreaFromMap().finally(function () {
                buildTable();
                loadKpi().catch(function () {});
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})(window, document);
